import { useCallback, useEffect, useRef, useState } from 'react'
import { copyAddress } from '../utils/wallet-actions'

const COPIED_FOR_MS = 2000

/** Copies an address; the button itself says "copied" for a moment. */
export const useCopyAddress = (address: string) => {
  const [isCopied, setIsCopied] = useState(false)
  const timerRef = useRef<ReturnType<typeof setTimeout>>()

  useEffect(() => () => clearTimeout(timerRef.current), [])

  const copy = useCallback(async () => {
    if (!(await copyAddress(address))) return

    setIsCopied(true)
    clearTimeout(timerRef.current)
    timerRef.current = setTimeout(() => setIsCopied(false), COPIED_FOR_MS)
  }, [address])

  return { isCopied, copy }
}
